import ApiClient from "../../../lib/apiClient";
import { ExpressionData } from "../types/types";

class DocumentTemplateApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getDocumentTemplateSchema = async (route?: string) => {
    return this._apiClient.get<ExpressionData[]>(
      route || `document-templates/schema`
    );
  };

  getDocumentTemplateFieldsData = async (
    modelName?: string,
    modelId?: string
  ) => {
    return this._apiClient.post<Record<string, string>>(
      `document-templates/fields-data`,
      {
        modelName,
        modelId,
      }
    );
  };

  updateDocumentTemplateFileFormData = async (
    templateId: string,
    fileFormData: string
  ) => {
    return this._apiClient.put<string>(
      `document-templates/${templateId}/file-form-data`,
      {
        fileFormData,
      }
    );
  };

  populateDocument = async (
    file?: string,
    fileFormData?: string,
    templateFieldsData?: Record<string, string>
  ) => {
    return this._apiClient.download<any>(`document-templates/populate/pdf`, {
      file,
      fileFormData,
      templateFieldsData,
    });
  };
}

export default DocumentTemplateApiClient;
